export default __webpack_public_path__ + "static/media/Beppe5.782c8914.jpg";